import React, { useState, useEffect } from 'react';

const API = 'https://khepri.tech/api/v1';

function Contracts() {
  const [text, setText] = useState('');
  const [signatureStatus, setSignatureStatus] = useState('');
  const [history, setHistory] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState('service');
  const [sendStatus, setSendStatus] = useState('');
  const token = localStorage.getItem('khepri_token');

  const templates = {
    service: { name: 'Услуги', subject: 'Консультационные услуги', amount: '500000', icon: '🤝' },
    supply: { name: 'Поставка', subject: 'Поставка товаров', amount: '800000', icon: '📦' },
    nda: { name: 'NDA', subject: 'Соглашение о неразглашении', amount: '0', icon: '🔒' },
    rent: { name: 'Аренда', subject: 'Аренда помещения', amount: '120000', icon: '🏠' },
    contract: { name: 'Подряд', subject: 'Выполнение подрядных работ', amount: '1500000', icon: '🔨' },
    license: { name: 'Лицензия', subject: 'Лицензионное соглашение', amount: '300000', icon: '📜' },
  };

  useEffect(() => {
    fetchContracts();
  }, []);

  const fetchContracts = async () => {
    try {
      const res = await fetch(API + '/contracts', {
        headers: { Authorization: 'Bearer ' + token },
      });
      if (res.ok) {
        const data = await res.json();
        setHistory(data.contracts || []);
      }
    } catch (err) {
      console.error('Fetch contracts error:', err);
    }
  };

  const generate = async (e) => {
    e.preventDefault();
    const form = new FormData(e.target);
    const payload = {
      contract_type: form.get('contract_type') || selectedTemplate,
      customer: form.get('customer') || 'ООО Заказчик',
      executor: form.get('executor') || 'ООО Исполнитель',
      subject: form.get('subject') || templates[selectedTemplate].subject,
      amount: form.get('amount') || templates[selectedTemplate].amount,
      deadline: form.get('deadline') || '2026-12-31',
    };

    try {
      const res = await fetch(API + '/contracts', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + token,
        },
        body: JSON.stringify(payload),
      });
      const data = await res.json();
      setText(data.text);
      setSignatureStatus('');
      setSendStatus('');
      fetchContracts();
    } catch (err) {
      console.error('Generate contract error:', err);
    }
  };

  const signDocument = () => {
    setSignatureStatus('pending');
    setTimeout(() => {
      setSignatureStatus('done');
    }, 2000);
  };

  const sendToCounterparty = () => {
    setSendStatus('sending');
    setTimeout(() => {
      setSendStatus('sent');
    }, 2000);
  };

  const downloadFile = () => {
    if (!text) return;
    const printWindow = window.open('', '_blank');
    printWindow.document.write('<html><head><title>Договор Khepri</title><style>body{font-family:Arial,sans-serif;padding:40px;line-height:1.6;white-space:pre-wrap;}</style></head><body>');
    printWindow.document.write(text.replace(/\n/g, '<br>'));
    printWindow.document.write('</body></html>');
    printWindow.document.close();
    printWindow.print();
  };

  const deleteRecord = async (id) => {
    try {
      await fetch(API + '/contracts/' + id, {
        method: 'DELETE',
        headers: { Authorization: 'Bearer ' + token },
      });
      fetchContracts();
    } catch (err) {
      console.error('Delete contract error:', err);
    }
  };

  return (
    <div>
      <h2 style={{ color: '#F7DE8A' }}>📄 Генератор договоров</h2>
      <p style={{ color: '#94A3B8', fontSize: 13, marginTop: 4, marginBottom: 12 }}>
        6 типов договоров с сохранением в базе данных
      </p>

      {/* Выбор шаблона */}
      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 16 }}>
        {Object.entries(templates).map(([key, tpl]) => (
          <button
            key={key}
            type="button"
            onClick={() => setSelectedTemplate(key)}
            style={{
              padding: '10px 16px',
              background: selectedTemplate === key ? '#F7DE8A' : '#1E293B',
              color: selectedTemplate === key ? '#0F172A' : '#94A3B8',
              border: selectedTemplate === key ? 'none' : '1px solid #8A6636',
              borderRadius: 20,
              cursor: 'pointer',
              fontSize: 13,
              fontWeight: selectedTemplate === key ? 700 : 500,
              display: 'flex',
              alignItems: 'center',
              gap: 6,
            }}
          >
            <span>{tpl.icon}</span> {tpl.name}
          </button>
        ))}
      </div>

      {/* Форма генерации */}
      <form onSubmit={generate} style={{ display: 'flex', flexDirection: 'column', gap: 10, marginTop: 12, maxWidth: 500 }}>
        <input type="hidden" name="contract_type" value={selectedTemplate} />
        <input name="customer" placeholder="Заказчик" defaultValue="ООО Заказчик" style={inputStyle} />
        <input name="executor" placeholder="Исполнитель" defaultValue="ООО Исполнитель" style={inputStyle} />
        <input name="subject" placeholder="Предмет договора" defaultValue={templates[selectedTemplate].subject} style={inputStyle} />
        {selectedTemplate !== 'nda' && (
          <input name="amount" placeholder="Сумма (₽)" defaultValue={templates[selectedTemplate].amount} style={inputStyle} />
        )}
        <input name="deadline" type="date" defaultValue="2026-12-31" style={inputStyle} />
        <button type="submit" style={{ padding: 14, background: '#F7DE8A', color: '#0F172A', border: 'none', borderRadius: 8, cursor: 'pointer', fontWeight: 700, fontSize: 16 }}>
          📄 Сгенерировать договор
        </button>
      </form>

      {/* Результат генерации */}
      {text && (
        <div style={{ marginTop: 20 }}>
          <div style={{ padding: 16, background: '#1E293B', borderRadius: 8, whiteSpace: 'pre-wrap', fontSize: 13, border: '1px solid #8A6636', lineHeight: 1.6 }}>
            {text}
          </div>

          {/* Кнопки действий */}
          <div style={{ marginTop: 12, display: 'flex', gap: 10, flexWrap: 'wrap' }}>
            <button
              onClick={signDocument}
              disabled={signatureStatus === 'pending' || signatureStatus === 'done'}
              style={{
                padding: '12px 24px',
                background: signatureStatus === 'done' ? '#10B981' : signatureStatus === 'pending' ? '#F59E0B' : '#F7DE8A',
                color: signatureStatus === 'done' ? '#fff' : '#0F172A',
                border: 'none',
                borderRadius: 8,
                cursor: signatureStatus === 'done' ? 'default' : 'pointer',
                fontWeight: 700,
              }}
            >
              {signatureStatus === 'done' ? '✅ Подписан (УКЭП)' : signatureStatus === 'pending' ? '⏳ Подписание...' : '✍️ Подписать УКЭП'}
            </button>

            <button onClick={downloadFile} style={{ padding: '12px 24px', background: '#8A6636', color: '#F8FAFC', border: 'none', borderRadius: 8, cursor: 'pointer', fontWeight: 600 }}>
              🖨️ Скачать / Печать
            </button>

            <button
              onClick={sendToCounterparty}
              disabled={sendStatus === 'sending' || sendStatus === 'sent'}
              style={{
                padding: '12px 24px',
                background: sendStatus === 'sent' ? '#10B981' : sendStatus === 'sending' ? '#F59E0B' : '#6366F1',
                color: '#fff',
                border: 'none',
                borderRadius: 8,
                cursor: sendStatus === 'sent' ? 'default' : 'pointer',
                fontWeight: 600,
              }}
            >
              {sendStatus === 'sent' ? '✅ Отправлено' : sendStatus === 'sending' ? '⏳ Отправка...' : '📧 Отправить контрагенту'}
            </button>
          </div>

          {signatureStatus === 'done' && (
            <p style={{ color: '#10B981', fontSize: 13, marginTop: 8 }}>
              Документ юридически подписан. Подпись PKCS#7 прикреплена.
            </p>
          )}
          {sendStatus === 'sent' && (
            <p style={{ color: '#10B981', fontSize: 13, marginTop: 8 }}>
              Договор отправлен контрагенту (демо-режим).
            </p>
          )}
        </div>
      )}

      {/* История из базы */}
      {history.length > 0 && (
        <div style={{ marginTop: 24 }}>
          <h3 style={{ color: '#F7DE8A', marginBottom: 12 }}>📋 История договоров (база данных)</h3>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
            {history.map((h) => (
              <div key={h.id} style={{ padding: 12, background: '#1E293B', borderRadius: 8, border: '1px solid #8A6636', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 10 }}>
                <div>
                  <div style={{ fontSize: 14, fontWeight: 600, color: '#F7DE8A' }}>{h.type_name}</div>
                  <div style={{ fontSize: 12, color: '#94A3B8', marginTop: 4 }}>
                    {h.customer} • {h.subject} • {h.amount} ₽
                  </div>
                </div>
                <button onClick={() => deleteRecord(h.id)} style={{ background: 'none', border: '1px solid #EF4444', color: '#EF4444', padding: '6px 12px', borderRadius: 6, cursor: 'pointer', fontSize: 12 }}>
                  Удалить
                </button>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

const inputStyle = {
  padding: 12,
  background: '#0F172A',
  border: '1px solid #8A6636',
  borderRadius: 8,
  color: '#F8FAFC',
  fontSize: 14,
};

export default Contracts;